export const PREMIUM_PERKS: string[] = [
  'No ads across every chat and channel',
  '4GB uploads and faster download speeds',
  'Exclusive stickers, reactions, and a badge',
  'Voice-to-text conversion for any message',
];
